import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-filter-time',
  templateUrl: './filter-time.component.html',
  styleUrls: ['./filter-time.component.scss'],
})
export class FilterTimeComponent {
  @Output() changeTime: EventEmitter<Date> = new EventEmitter<Date>();
  @Input() set maxTime(time: Date) {
    this._maxTime = time;
  }

  @Input() set minTime(time: Date) {
    this._minTime = new Date(time);
  }

  @Input() set time(time: Date) {
    if (this._time?.getTime() === time?.getTime()) return;
    this._time = time;
  }

  public _time: Date;
  public _maxTime: Date;
  public _minTime: Date;
  public step = 1;

  public onChangeTime(time: Date): void {
    if (dayjs(this._time).isSame(dayjs(time))) return;
    if (!this.isAllowed(time)) {
      this._time = new Date(this._time.toISOString());

      return;
    }
    this._time = time;
    this.changeTime.emit(this._time);
  }

  private isAllowed(time: Date): boolean {
    if (!time) return false;
    if (
      this._time.getHours() === 23 &&
      this._time.getMinutes() == 59 &&
      time.getHours() === 0 &&
      time.getMinutes() === 0
    )
      return false;
    if (
      this._time.getHours() === 0 &&
      this._time.getMinutes() === 0 &&
      time.getHours() === 23 &&
      time.getMinutes() === 59
    )
      return false;

    return true;
  }
}
